import { render, staticRenderFns } from "./HarmonizedSummary.vue?vue&type=template&id=b5ba3aa0&scoped=true&"
import script from "./HarmonizedSummary.vue?vue&type=script&lang=js&"
export * from "./HarmonizedSummary.vue?vue&type=script&lang=js&"
import style0 from "./HarmonizedSummary.vue?vue&type=style&index=0&id=b5ba3aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ba3aa0",
  null
  
)

export default component.exports